import { Conversations451Api } from '../conversations451';

export enum TriggerType {
  ApplicationCompleted = 'application_completed',
  ApplicationStarted = 'application_started',
  ApplicationSubmitted = 'application_submitted',
  ApplicationRecommendationSubmitted = 'application_recommendation_submitted',
  ApplicationPaid = 'application_paid',
  ApplicationPaymentSubmitted = 'application_payment_submitted',

  DecisionChecklistUpdated = 'decision_checklist_updated',
  DecisionChecklist = 'decision_checklist',
  DecisionChecklistCompleted = 'decision_checklist_completed',
  DecisionReleased = 'decision_released',
  DecisionStageUpdated = 'decision_stage_updated',
  DecisionStageChanged = 'decision_stage_changed',
  DecisionStatusUpdated = 'decision_status_updated',
  DecisionStatusChanged = 'decision_status_changed',

  ConversationStarted = 'conversation_started',

  EventSignup = 'event_signup',

  FormSubmitted = 'form_submitted',
  UserFormSubmitted = 'user_form_submitted',

  EnteredSegment = 'entered_segment',
  ExitedSegment = 'exited_segment',
  EnteredOrExitedSegment = 'entered_exited_segment',

  UserLabelAdded = 'user_label_added',
  UserLabelRemoved = 'user_label_removed',
  UserBirthday = 'user_birthday',

  UserTerritoryChanged = 'user_territory_changed',

  AppointmentAttended = 'appointments_attended',
  AppointmentCanceled = 'appointments_canceled',
  AppointmentNoShow = 'appointments_no_show',
  AppointmentScheduled = 'appointment_scheduled',
  AppointmentUpdated = 'appointments_updated',
  DocumentUpload = 'document_uploaded'
}

export interface ApplicationParameters {
  application_guid?: string;
  term?: string;
  major?: string;
}

export interface ApplicationPaymentSubmittedParameters {
  application_guid?: string;
  term?: string;
  major?: string;
  payment_method?: string;
}

export interface RecommendationSubmittedParameters {
  application_guid?: string;
}

export interface ConversationParameters {
  channel?: Conversations451Api.DeliveryMethod;
}

export interface AppointmentParameters {
  appointment_category?: string;
  appointment_type?: string;
  appointment_assignee?: string;
}

export interface DecisionChecklistItemsParameters {
  item_key: string;
  status: string;
  application_guid?: string;
}

export interface DecisionReleasedParameters {
  application_guid?: string;
  status_guid?: string;
}

export interface DecisionStatusChangedParameters {
  status_guid: string;
  application_guid?: string;
}

export interface DocumentUploadedParameters {
  document_type_guid: string;
}

export interface DecisionStageChangedParameters {
  application_guid?: string;
  stage_id: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BirthdayParameters {}

export enum TriggerFormOn {
  Both = '',
  Main = 'main',
  FollowUp = 'follow_up'
}

export interface FormParameters {
  form_guid: string;
  trigger_on?: TriggerFormOn;
}

export interface SegmentParameters {
  segment_guid: string;
}

export interface LabelParameters {
  label_guid: string;
}

export interface TerritoryParameters {
  territory_guid: string;
}

export interface EventParameters {
  event_guid: string;
}

export type TriggerParameters =
  | FormParameters
  | SegmentParameters
  | LabelParameters
  | TerritoryParameters
  | EventParameters
  | ApplicationParameters
  | ApplicationPaymentSubmittedParameters
  | RecommendationSubmittedParameters
  | ConversationParameters
  | AppointmentParameters
  | DecisionChecklistItemsParameters
  | DecisionReleasedParameters
  | DecisionStatusChangedParameters
  | DocumentUploadedParameters
  | DecisionStageChangedParameters
  | BirthdayParameters;
